var e = /* @__PURE__ */ ((l) => (l.Default = "default", l.ImageOnly = "imageOnly", l.Full = "full", l))(e || {});
const f = "change";
export {
  f as CHANGE_EVENT,
  e as VariantsEnum
};
